import { withFetchPatient } from '../../components/hoc/withFetchPatient';
import { FormStartComponent } from './index';

export const FormStartMulti = withFetchPatient(FormStartComponent, {
  multi: true,
});
